import {
  FETCH_INDEX_POSTS,
  FETCH_SHOW_POSTS,
  FETCH_SINGLE_POST,
  GET_INDEX_POSTS,
  GET_INDEX_POSTS_BY_CAT,
  GET_TOTAL_SHOW_PAGE,
  GET_TOTAL_INDEX_PAGE,
  GET_SHOW_POSTS,
  GET_INDEX_PAGE,
  GET_CATEGORIES,
  GET_SINGLE_POST,
  SET_CURRENT_SHOW_PAGE,
  SET_CURRENT_INDEX_PAGE,
  SET_CURRENT_SINGLE_SLUG,
  INDEX_OPEN,
  INDEX_CLOSE
} from '../actions/const';

import $ from 'jquery';
let config = require('config');

const initialState = {
  totalShowPage:null,
  totalIndexPage:null,
  showPosts:null,
  indexPages:null,
  indexPosts:null,
  categories:null,
  currentShowPage:1,
  currentIndexPage:1,
  currentSingleSlug:null,
  singlePost:null,
  selectCat:null,
  indexOpen:false,
  scrollTop:0,
  lastIndexPath:null
};

module.exports = function(state = initialState, action) {
  switch(action.type) {
    case FETCH_INDEX_POSTS: {
      return Object.assign({}, state, {
        indexPosts:null
      })
    } break;
    case FETCH_SHOW_POSTS: {
      return Object.assign({}, state, {
        showPosts:null
      })
    } break;
    case FETCH_SINGLE_POST: {
      return Object.assign({}, state, {
        singlePost:null
      })
    } break;
    case GET_INDEX_POSTS: {
      return Object.assign({}, state, {
        indexPosts:action.body,
        currentIndexPage:parseInt(action.offset)+1,
        selectCat:null,
        lastIndexPath:"/"
      })
    } break;
    case GET_INDEX_POSTS_BY_CAT: {
      return Object.assign({}, state, {
        indexPosts:action.body,
        currentIndexPage:parseInt(action.offset)+1,
        selectCat:action.cat,
        lastIndexPath:"/?cat="+action.cat
      })
    } break;
    case GET_SHOW_POSTS: {
      return Object.assign({}, state, {
        showPosts:action.body,
        currentShowPage:parseInt(action.offset)+1
      })
    } break;
    case GET_TOTAL_SHOW_PAGE: {
      var totalpage = Math.ceil(parseInt(action.body.total) / config.default.PAGE_MAX)
      return Object.assign({}, state, {
        totalShowPage:totalpage,
        totalIndexPage:totalpage
      })
    } break;
    case GET_TOTAL_INDEX_PAGE: {
      var totalpage = Math.ceil(parseInt(action.body.total) / config.default.PAGE_MAX)
      return Object.assign({}, state, {
        totalIndexPage:totalpage
      })
    } break;
    case GET_INDEX_PAGE: {
      return Object.assign({}, state, {
        indexPages:action.body
      })
    } break;
    case GET_CATEGORIES: {
      return Object.assign({}, state, {
        categories:action.body
      })
    } break;
    case GET_SINGLE_POST: {
      return Object.assign({}, state, {
        singlePost:action.body,
        currentSingleSlug:action.slug
      })
    } break;
    case SET_CURRENT_SHOW_PAGE: {
      return Object.assign({}, state, {
        currentShowPage:action.num
      })
    } break;
    case SET_CURRENT_INDEX_PAGE: {
      return Object.assign({}, state, {
        currentIndexPage:action.num
      })
    } break;
    case SET_CURRENT_SINGLE_SLUG: {
      return Object.assign({}, state, {
        currentSingleSlug:action.slug
      })
    } break;
    case INDEX_OPEN: {
      return Object.assign({}, state, {
        indexOpen:true,
        scrollTop:action.scrollTop
      })
    } break;
    case INDEX_CLOSE: {
      return Object.assign({}, state, {
        indexOpen:false,
        indexPosts:null,
        currentIndexPage:1,
        totalIndexPage:null,
        selectCat:null
      })
    } break;
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/data.js